import React, { useState } from "react";
import { Modal, Input, Form } from "antd";
import { Link } from 'react-router-dom'
function ForgotPassword({ forgotPasswordVisible, setForgotPasswordVisible, setLoginVisible}) {
    const handleLogin = (e) =>{
        setLoginVisible(true);
        setForgotPasswordVisible(false);
    };
    const handleCancel = (e) => {
        setForgotPasswordVisible(false);
    };

    const onFinish = (values) => {
        console.log('succes:', values);
    };

    const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };
    return (
        <div className="modalBox">
            
            <Modal
                destroyOnClose={true}
                title="Quên mật khẩu"
                className=" modalForgotPassword modalStyle "
                visible={forgotPasswordVisible}
                onCancel={handleCancel}
                footer={null}
            >
                <Form
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}>
                    <p>Vui lòng nhập Email hoặc SĐT để đổi mật khẩu</p>
                    <Form.Item className="formInput"
                        label="EMAIL HOẶC SỐ ĐIỆN THOẠI"
                        name="email"
                    >
                        <Input
                            type="text"
                            placeholder="Nhập email hoặc số điện thoại"
                        />
                    </Form.Item>
                    <Form.Item className="btnModal">
                        <button className="btnStyle" >
                            Gửi
                        </button>
                    </Form.Item>
                    <div className="register">Nhớ thông tin đăng nhập? <Link onClick={handleLogin} to="#">Đăng nhập ngay</Link></div>
                </Form>
            </Modal>
        </div>
    )

}
export default ForgotPassword;